import * as React from 'react';
import { useState, useContext, useEffect } from 'react';
import {DataContext} from "~common/form/icg-definition-data-provider";
import { Paper } from '@mui/material';
import LoadingView from '~common/components/loading-view';
import ErrorView from '~common/components/error-view';
import DefinitionSection from '~common/form/definition-section-fc';
import { StylesProvider } from '@mui/styles';
import { ThemeProvider } from '@mui/styles';
import {
	theme,
  } from "~common/components/app-view/theme";
  import { makeStyles, Theme, createStyles } from "@mui/styles";
  import {cloneDeep} from 'lodash'


const useStyles = makeStyles((theme: Theme) =>
 	 createStyles({
		container: {
			width: '100%',
		},
		actionsContainer: {
			marginBottom: 5
		},
		instructionContainer: {
			marginBottom: 5
		},
		formContainer: {
			paddingTop: 5
		},
		paperContainer: {
			padding: 10
		}
	})
);

interface Props {
	history?: any;
	entityDataField: string;
	returnURL?: string;
	readOnly?: any;
	preventCollapse?: boolean;
	viewTitle?: () => {}
}

export const DefinitionSectionViewer: React.FC<Props> = ({

}) => {
	const classes = useStyles();    

	const [fullData, setFullData] = useContext(DataContext);
	const [definition, setDefinition] = useState(undefined)
	const [status, setStatus] = useState("loading")
	const [error, setError] = useState(undefined)
	const [sourceGridAttributes, setSourceGridAttributes] = useState(undefined)

	const onErrorViewClose = () => {
		
	}

	const handleMessage = (message:any) => {
		// console.log("handleMessage", message)
		if (message && message.data.action) {
			
			switch ((message.data.action || "").toLowerCase()) {
				case "close":
					window.close()
					break;
				case "onreadystatechange":
					if (message && message.data && message.data.definition) {
						message.data.definition.gridAttributes = {xs: 12,sm: 12,m: 12,lg: 12,xl: 12}

						setDefinition(message.data.definition)
						setFullData(message.data.data || {})
						setSourceGridAttributes(message.data.sourceGridAttributes)
						setStatus("ready")

						window.opener.postMessage({
							action: "expand",
							sectionGridAttributes: message.data.definition.popperAttributes.gridAttributes,
						}, window.location.origin)

					}
					break;
				case "datadidupdate":
					// this ensures the data here is updated during get-next
					setFullData(message.data.data || {})
					setStatus("ready")
					break;
			}
		}
	}

	useEffect(()=>{ 

		// send reset to opener
		window.addEventListener("beforeunload", function (event) {
			window.opener.postMessage({
				action: "reset",
			}, window.location.origin)
		});

		// Listen for the supported messages
		window.addEventListener("message", (event) => {
			handleMessage(event)
		}, false)

		// signal the opener that we are ready
		if (window.opener) {
			window.opener.postMessage({ action: "ready" }, window.location.origin)
		} 

	}, [])

	useEffect(()=>{ 
		if (definition) {
			const msg: any = {
				key: definition.key,
				value: fullData,
			}
			window.opener.postMessage({action: "handlechangeatpath", data: msg}, window.location.origin)
		}

	}, [fullData])

	var errorView;
	if (error) {
		errorView = <ErrorView classes={{}} error={error} onClose={onErrorViewClose} />;
	}

	// console.log("status", status)
	// console.log("definition", definition)
	// console.log("fullData", fullData)

	switch (status) {
		case 'loading':
			return (
				<div className={classes.container}>
					{errorView}
					<LoadingView classes={{}} />
				</div>
			);
		case 'ready':
			return (
				<StylesProvider>
					<ThemeProvider theme={theme}>
						<div className={classes.container}>
							{errorView}
							<Paper className={classes.paperContainer}>
								<DefinitionSection
									definition={definition}
									path={''}
									divSpacing={4}
									preventCollapse={true}
								/>
							</Paper>
						</div>
					</ThemeProvider>
				</StylesProvider>
			);
	}
};
  
export default DefinitionSectionViewer;
